// todo cover.lv remove unused flags
export enum FeatureFlag {
  H2Integration = 'H2Integration',
  alphaLogo = 'alphaLogo',
  profilePage = 'profilePage',
  agentBuySellHistory = 'agentBuySellHistory',
  holderLabel = 'holderLabel',
  newAgentCard = 'newAgentCard',
}

// Utility type to extract keys from the enum
export type FeatureFlagKeys = keyof typeof FeatureFlag;

export const isFeatureEnabled = (flag: FeatureFlagKeys): boolean =>
  !!configs[process.env.APP_ENV][flag];

const configs: Record<
  typeof process.env.APP_ENV,
  Partial<Record<FeatureFlag, true>>
> = {
  dev: {
    [FeatureFlag.H2Integration]: true,
    [FeatureFlag.alphaLogo]: true,
    [FeatureFlag.profilePage]: true,
    [FeatureFlag.agentBuySellHistory]: true,
    [FeatureFlag.holderLabel]: true,
    [FeatureFlag.newAgentCard]: true,
  },
  sta: {
    [FeatureFlag.H2Integration]: true,
    [FeatureFlag.alphaLogo]: true,
    [FeatureFlag.newAgentCard]: true,
  },
  uat: {
    [FeatureFlag.alphaLogo]: true,
    [FeatureFlag.H2Integration]: true,
    [FeatureFlag.newAgentCard]: true,
  },
  prod: {
    [FeatureFlag.alphaLogo]: true,
    [FeatureFlag.H2Integration]: true,
  },
};
